import React from 'react';
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg';
import './plainNavbar.scss';
import { useNavigate } from 'react-router-dom';
import Button from '../../common/button/button';

type Props = {
  children: React.ReactNode;
  save?: Function;
  saveText?: string;
  cancel?: Function;
  cancelText?: string;
  route?: string;
  customButton?: React.ReactNode;
  useClose?: boolean;
  backgroundColor?: string;
};

const plainNavbar: React.FC<Props> = ({
  children,
  save,
  saveText = '저장',
  cancel,
  cancelText = '취소',
  route,
  customButton,
  useClose = true,
  backgroundColor = '#ffffff',
}) => {
  const navigate = useNavigate();

  const onCloseClick = () => {
    if (route) {
      navigate(`/${route}`);
    } else {
      navigate(-1);
    }
  };

  const onCancelClick = () => {
    if (cancel) {
      cancel();
    } else {
      navigate(-1);
    }
  };

  document.documentElement.style.setProperty('--backgroundColor', `${backgroundColor}`);

  return (
    <div className="background">
      {useClose && (
        <div className="plainNavbarHead">
          <div className="closeIcon" onClick={onCloseClick}>
            <CloseIcon />
          </div>
        </div>
      )}
      <div className="plainNavContainer">{children}</div>
      <div className="plainNavbarFooter">
        {!customButton ? (
          <div className="plainNavbarFooter__action">
            <div className="plainNavbarFooter__cancel">
              <Button label={cancelText} type="type1" height={42} action={onCancelClick} />
            </div>
            <div>
              <Button label={saveText} type="type2" height={42} action={save} />
            </div>
          </div>
        ) : (
          <div className="plainNavbarFooter__action">{customButton}</div>
        )}
      </div>
    </div>
  );
};

export default plainNavbar;
